import React, { useEffect, useRef, useState } from "react";

export default function Typewriter({ text = "", speed = 28, className = "", as: Tag = "span", startOnView = true, caret = true }) {
  const [out, setOut] = useState("");
  const [go, setGo] = useState(!startOnView);
  const ref = useRef(null);

  useEffect(() => {
    if (go) return;
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) { setGo(true); return; }
    const obs = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { setGo(true); obs.disconnect(); } }), { threshold: 0.25 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [go]);

  useEffect(() => {
    if (!go) return;
    setOut("");
    let i = 0;
    const id = setInterval(() => { i += 1; setOut(text.slice(0, i)); if (i >= text.length) clearInterval(id); }, speed);
    return () => clearInterval(id);
  }, [text, go, speed]);

  const done = out.length >= text.length;
  return (
    <Tag ref={ref} className={className} style={{ position: "relative", display: "inline-block", width: "100%" }}>
      <span style={{ visibility: "hidden" }} aria-hidden="true">{text}</span>
      <span style={{ position: "absolute", left: 0, top: 0, width: "100%" }}>
        {out}{caret && <span className={`tw-caret ${done ? "tw-caret-done" : ""}`} aria-hidden="true">|</span>}
      </span>
    </Tag>
  );
}
